import React, { useState } from 'react';

import { InfoMessage } from '@eika/attention-message';
import { Button, RowButton } from '@eika/button';
import { Icon, IconTypes } from '@eika/icon';
import { RadioButtons } from '@eika/radio-button';

import type { ChargeBearerOptions } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import { EikaModal } from '../../EikaModal';
import { StickyFooterRow } from '../../shared/StickyFooter';

import './ChargeBearerField.scss';

interface Props {
    label: string;
    chargeBearer?: ChargeBearerOptions;
    options?: ChargeBearerOptions[];
    onChange: (value: ChargeBearerOptions) => void;
}

const ChargeBearerField: React.FC<Props> = ({ label, chargeBearer, options, onChange }) => {
    const translated = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const showInfoMessage = chargeBearer === 'SENDER';

    const setNewChargeBearerOption = (value: string) => {
        onChange(value as ChargeBearerOptions);
    };

    return (
        <>
            <RowButton onClick={() => setShowModal(true)}>
                <div className="charge-bearer-field__layout">
                    <div className="charge-bearer-field__label">
                        <span className="charge-bearer-field__label">{label}</span>
                        <span className="charge-bearer-field__value">
                            {chargeBearer && translated.chargeBearerOptions[chargeBearer]}
                        </span>
                    </div>
                    <div className="charge-bearer-field__icon">
                        <Icon type={IconTypes.LITEN_PIL_HOEYRE} className="icon--20" ariaLabel="Endre" />
                    </div>
                </div>
            </RowButton>
            <EikaModal
                id="chargeBearerField"
                open={showModal}
                setOpen={setShowModal}
                title={translated.chargeBearerField.title}
            >
                {options && (
                    <RadioButtons
                        label={translated.chargeBearerField.description}
                        className="charge-bearer-field__options"
                        onChange={setNewChargeBearerOption}
                        options={options.map((option) => {
                            return { value: option, label: translated.chargeBearerSelectOptions[option] };
                        })}
                        selectedOption={chargeBearer}
                    />
                )}
                {showInfoMessage && (
                    <InfoMessage
                        className="charge-bearer-field__info-message"
                        text={translated.chargeBearerField.infoMessage}
                    />
                )}
                <StickyFooterRow>
                    <Button size="small" className="charge-bearer-field__button" onClick={() => setShowModal(false)}>
                        {translated.continue}
                    </Button>
                </StickyFooterRow>
            </EikaModal>
        </>
    );
};

export default ChargeBearerField;
